import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Inscription from "./views/Inscription.vue";
import Inscription_histoire from "./views/Inscription-histoire.vue";
import Inscription_email from "./views/Inscription-email.vue";
import Inscription_private from "./views/Inscription-private.vue";
import Inscription_public from "./views/Inscription-public.vue";
import Inscription_picture from "./views/Inscription-picture.vue";
import Inscription_final from "./views/Inscription-final.vue";
import Conversations from "./views/Conversations.vue";
import Messages from "./views/Messages.vue";
import Profil_day from "./views/Profil-day.vue";
import Profil from "./views/Profil.vue";
import Login from "./views/Login.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/inscription",
            name: "inscription",
            component: Inscription
        },
        {
            path: "/inscription-histoire",
            name: "inscription-histoire",
            component: Inscription_histoire
        },
        {
            path: "/inscription-email",
            name: "inscription-email",
            component: Inscription_email
        },
        {
            path: "/inscription-private",
            name: "inscription-private",
            component: Inscription_private
        },
        {
            path: "/inscription-public",
            name: "inscription-public",
            component: Inscription_public
        },
        {
            path: "/inscription-picture",
            name: "inscription-picture",
            component: Inscription_picture
        },
        {
            path: "/inscription-final",
            name: "inscription-final",
            component: Inscription_final
        },
        {
            path: "/login",
            name: "login",
            component: Login
        },
        {
            path: "/conversations",
            name: "conversations",
            component: Conversations
        },
        {
            path: "/conversations/:id/messages",
            name: "messages",
            component: Messages
        },
        {
            path: "/conversations-day",
            name: "conversations-day",
            component: Profil_day
        },
        {
            path: "/profil/:id",
            name: "profil",
            component: Profil
        },
        {
            path: "/about",
            name: "about",
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import( /* webpackChunkName: "about" */ "./views/About.vue")
        }
    ]
});